import { IMPORT_CUSTOMERS } from '../constants';

const initialState = {
  count: 0,
  page: 1,
  totalPages: 1,
};
function lettersPagination(state = initialState, action) {
  switch (action.type) {
    case IMPORT_CUSTOMERS:
      return action.pagination;
    default:
      return state;
  }
}

export default lettersPagination;
